import { render, staticRenderFns } from "./wizard2.vue?vue&type=template&id=34a9989e"
import script from "./wizard2.vue?vue&type=script&lang=js"
export * from "./wizard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/product/wizard2.vue
// module id = null
// module chunks = 